import {
  ISoccerMatchGoalEvent,
  ISoccerMatchGoalEventWithCount,
} from "../../../../types";

type GoalEventIconProps = {
  event: ISoccerMatchGoalEvent | ISoccerMatchGoalEventWithCount;
  iconSize?: number;
  showTime?: boolean;
  showCount?: boolean;
  wrapperClassName?: string;
  timeClassName?: string;
  countClassName?: string;
};

const goalTypeMap = {
  G: "/images/match-events/goal-bg.svg",
  PG: "/images/match-events/penalty-goal-bg.svg",
  OG: "/images/match-events/own-goal.svg",
};

export function GlobalGoalEvent({
  event,
  iconSize = 16,
  showTime = false,
  showCount = false,
  wrapperClassName = "",
  timeClassName = "",
  countClassName = "event-count",
}: GoalEventIconProps) {
  const goalImgSrc = goalTypeMap[event.type as keyof typeof goalTypeMap] || "";

  return (
    <div className={wrapperClassName}>
      {showCount && "count" in event && event.count > 1 && (
        <span className={countClassName}>{event.count}</span>
      )}
      <img
        src={goalImgSrc}
        height={iconSize}
        width={iconSize}
        alt="goal"
        className="goal-event"
      />
      {showTime && (
        <span className={timeClassName}>{`${event?.timeMin}'`}</span>
      )}
    </div>
  );
}
